import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  dialogOptions: {
    type: 'panel',
    size: 'full'
  }
} satisfies RecursivePartial<DialogConfig['signIn']>
